import Vue from 'vue'
import Router from 'vue-router'
import {isMobile } from '@/../store/store';
const both = (name) => () => import(`@/views/${name}`);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
// isMobile() ? both('wap') : both('index')
var routes=[
	{
		path: '/home',
		name: '新首页',
		component: both('home'),
	},
	{
		path: '/index',
		name: '首页',
		component: both('index'),
	},
	{
		path: '/lease',
		name: '房产租赁',
		component: both('lease'),
	},
	{
		path: '/business',
		name: '房产买卖',
		component: both('business'),
	},
	{
		path: '/transaction',
		name: '房产买卖1',
		component: both('business'),
	},
	{
		path: '/entrust',
		name: '委托管理',
		component: both('entrust'),
	},
	{
		path: '/renovation',
		name: '装修业务',
		component: both('renovation'),
	},
	{
		path: '/renovation_info',
		name: '装修业务详情',
		component: both('renovation_info'),
	},
	{
		path: '/move',
		name: '搬家业务',
		component: both('move'),
	},
	{
		path: '/news',
		name: '新闻中心',
		component: both('news'),
	},
	{
		path: '/news_info',
		name: '新闻中心详情',
		component: both('news_info'),
	},
	{
		path: '/recruit',
		name: '招聘中心',
		component: both('recruit'),
	},
	{
		path: '/recruit_info',
		name: '招聘详情',
		component: both('recruit_info'),
	},
	{
		path: '/about',
		name: '关于我们',
		component: both('about'),
	},
	{
		path: '/contact',
		name: '联系我们',
		component: both('contact'),
	},
	{
		path: '/details',
		name: '房源详情',
		component: both('details'),
	},
	{
		path: '/map',
		name: '地图',
		component: both('map'),
	},
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js